<template>
  <div :data-api-key="apiKey" data-el="api-key-wrapper">
    <FormGroup label="API access key" :size="size">
      <FormInputGroup>
        <FormInputIcon icon="apiKey" />
        <FormInput
          class="flex-1 border-0 font-mono"
          data-id="api-key-input"
          :value="apiKey"
          in-group
          size="sm"
        />
        <CopyButton
          :value="apiKey"
          size="sm"
          in-group
          :variant="Variant.white"
        />

        <FormDropDown position="bottom-left" size="sm" in-group>
          <template #button-content>
            <Icon icon="cog" />
          </template>
          <FormDropDownItem
            ref="apiKeyRefresh"
            button
            @click="requestApiKeyRefresh"
          >
            {{ 'Regenerate API Key' }}
          </FormDropDownItem>
          <FormDropDownItem
            v-if="!noSettingsLink"
            ref="settings"
            href="/settings"
          >
            {{ 'Account settings' }}
          </FormDropDownItem>
        </FormDropDown>
      </FormInputGroup>
    </FormGroup>
  </div>
</template>
<script setup lang="ts">
import Icon from '../../components/form/Icon.vue';
import FormInput from '../../components/form/FormInput.vue';
import FormInputIcon from '../../components/form/FormInputIcon.vue';
import { ref, computed } from 'vue';
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import FormDropDown from '../../components/form/FormDropDown.vue';
import FormDropDownItem from '../../components/form/FormDropDownItem.vue';
import CopyButton from '../../components/CopyButton.vue';
import FormInputGroup from '../../components/form/FormInputGroup.vue';
import { Variant } from '../../store/types';
import FormGroup from '../../components/form/FormGroup.vue';
import { navigateTo } from '#imports';
import type { FormSize } from '../../lib/services/types';

withDefaults(
  defineProps<{
    size?: FormSize;
    noSettingsLink?: boolean;
  }>(),
  {
    size: 'lg',
    noSettingsLink: false,
  },
);
const loading = ref(false);
const store3 = useStore3();
const apiKeyRefresh = ref(null);
const settings = ref(null);
const { user, regressionTest } = storeToRefs(store3);
const apiKey = computed(() => {
  if (regressionTest.value) {
    return 'api-key';
  } else {
    return user.value?.apiKey ?? '';
  }
});

const requestApiKeyRefresh = async () => {
  if (
    confirm(
      'Create new API key? Your existing API key will become invalid and you will need to login again.',
    )
  ) {
    loading.value = true;
    await store3.refreshApiKey();
    loading.value = false;
    await navigateTo('/login');
  }
};
</script>
